import WelcomeScreen from "../WelcomeScreen/WelcomeScreen";
export default WelcomeScreen;
